<nz-drawer
  [(nzVisible)]="isVisible"
  [nzTitle]="''"
  (nzOnClose)="onClose()"
  [nzPlacement]="placement"
  [nzClosable]="false"
  [nzWidth]="'100%'"
  [nzBodyStyle]="{
    padding: '0px',
  }"
  [nzMaskStyle]="{
    backgroundColor: 'rgba(0, 0, 0, ' + maskOpacity + ')'
  }"
>
  <ng-container *nzDrawerContent>
    <ng-content></ng-content>
  </ng-container>

  <div *nzDrawerFooter>
    <div class="w-full flex justify-end rounded-md p-4">
      <div class="flex gap-2">
        @if (alternativeActionButtonText) {
          <app-mb-button
            [label]="alternativeActionButtonText"
            (click)="alternativeActionHandler.emit()"
            type="ghost"
            [loading]="loading"
          />
        }
        <app-mb-button
          [label]="okText"
          (click)="onOk()"
          type="secondary"
          [disabled]="okDisabled"
          [loading]="loading"
        />
      </div>
    </div>
  </div>
</nz-drawer>